import { CheckboxProps, Checkbox, withStyles } from "@material-ui/core";
import { getCurrentAccentColor } from "../../../utils/styles";

function CustomCheckBox(props: CheckboxProps) {
  const GlydeCheckbox = withStyles({
    root: {
      color: getCurrentAccentColor(),
      "&$checked": {
        color: getCurrentAccentColor(),
      },
    },
    checked: {},
  })((props: CheckboxProps) => <Checkbox color="default" {...props} />);

  return <GlydeCheckbox {...props} />;
}

export default CustomCheckBox;
